import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { DialogNgbService, PipesModule, QuizModule } from '@motivforce/mx-library-angular';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { DialogComponent } from './components/dialog/dialog.component';
import { EditCompanyContactDialogComponent } from './components/edit-company-contact-dialog/edit-company-contact-dialog.component';
import { PromotionPowDialogComponent } from './components/promotion-pow-dialog/promotion-pow-dialog.component';
import { SalesAcceleratorInfoDialogComponent } from './components/sales-accelerator-info-dialog/sales-accelerator-info-dialog.component';
import { TermsConditionsAcceptDialogComponent } from './components/terms-conditions-accept-dialog/terms-conditions-accept-dialog.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';

@NgModule({
  declarations: [
    DialogComponent,
    TermsConditionsAcceptDialogComponent,
    PromotionPowDialogComponent,
    ConfirmationDialogComponent,
    SalesAcceleratorInfoDialogComponent,
    EditCompanyContactDialogComponent,
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    RouterModule,
    QuizModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    PipesModule,
  ],
  exports: [NgbModalModule],
})
export class DialogModule {
  constructor(private dialog: DialogNgbService, private iconlibrary: FaIconLibrary) {
    this.dialog.registerNotificationDialog(DialogComponent);
    this.dialog.registerErrorDialog(DialogComponent);
    this.dialog.registerWarningDialog(DialogComponent);
    this.dialog.registerValidationDialog(DialogComponent);
    this.dialog.registerConfirmationDialog(ConfirmationDialogComponent);

    this.dialog.registerFeatureDialog('termsConditionsAcceptDialog', TermsConditionsAcceptDialogComponent);
    this.dialog.registerFeatureDialog('promotionPowDialog', PromotionPowDialogComponent);
    this.dialog.registerFeatureDialog('salesAcceleratorsInfoDialog', SalesAcceleratorInfoDialogComponent);
    this.dialog.registerFeatureDialog('editCompanyContactDialog', EditCompanyContactDialogComponent);

    this.iconlibrary.addIcons(faClock);
  }
}
